var React = require('react');

function CheckIconBlue (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M17.5 9L13.75 13L10 17L8 15L6.5 13.5M12 23.249C18.2132 23.249 23.25 18.2122 23.25 11.999C23.25 5.7858 18.2132 0.749001 12 0.749001C5.7868 0.749001 0.75 5.7858 0.75 11.999C0.75 18.2122 5.7868 23.249 12 23.249Z","stroke":"#00648D","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round"}));
}

CheckIconBlue.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = CheckIconBlue;

CheckIconBlue.default = CheckIconBlue;
